export default __webpack_public_path__ + "static/media/cloud4.d6d2482c.png";